import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";

const api = "https://apideneme.com.tr/api/users";

const EditUser = () => {
    const [id, setId] = useState(""); // id'yi burada tanımlıyoruz
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [error, setError] = useState(""); // Hata mesajlarını göstermek için ekledik
    const navigate = useNavigate();
    const { id: paramId } = useParams();

    useEffect(() => {
        const storedUserId = Cookies.get("user_id");
        if (!storedUserId) {
            navigate("/login"); // Giriş yapmamışsa login sayfasına yönlendir
        }
    }, [navigate]);

    const update = async (e) => {
        e.preventDefault();
        const updatedData = {
            name,
            email
        };
    
        try {
            // 'POST' ile güncelleme işlemi yapıyoruz
            const response = await axios.post(`${api}/${id}`, updatedData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
    
            console.log("Güncelleme yanıtı:", response.data);
            //alert("Kullanıcı başarıyla güncellendi!");
    
            // Yönlendirme işlemi
            const userId = Cookies.get("user_id");
            if (userId === "1") {
                navigate("/showusers"); // Adminse /users sayfasına yönlendir
            } else {
                navigate("/user-items"); // Admin değilse /user-items sayfasına yönlendir
            }
        } catch (error) {
            console.error("Güncelleme sırasında hata oluştu:", error);
            setError("Güncelleme işlemi başarısız oldu!"); // Hata mesajı gösteriyoruz
        }
    };
    

    useEffect(() => {
        const getUserById = async () => {
            try {
                const userId = Cookies.get("user_id"); // Cookie'den user_id'yi alıyoruz
                const response = await axios.get(`${api}/${paramId}`, {
                    params: { user_id: userId }, // user_id parametresini query olarak ekliyoruz
                });
                setId(response.data.id); 
                setName(response.data.name);
                setEmail(response.data.email);
            } catch (error) {
                console.error("Veri alınırken hata:", error);
                setError("Veri alınırken bir hata oluştu!"); // Hata mesajı gösteriyoruz
            }
        };

        getUserById();
    }, [paramId]); // paramId değiştiğinde yeniden çalışacak

    const handleBack = () => {
        const userId = localStorage.getItem('user_id');
        if (userId === "1") {
            navigate("/showusers"); // Adminse users sayfasına yönlendir
        } else {
            navigate("/user-items"); // Diğer kullanıcılar için user-items sayfasına yönlendir
        }
    };

    return (
        <div>
            <button 
                className="btn btn-secondary position-absolute" 
                style={{ top: '10px', right: '10px' }} 
                onClick={handleBack}
            >
                BACK
            </button>
            
            <h3>Kullanıcı Düzenle</h3>
            <div className="container">
                <div className="row d-flex align-items-center justify-content-center">
                    <div className="col-md-6">
                        {error && <p className="text-danger">{error}</p>} {/* Hata mesajını göster */}
                        <form onSubmit={update}>
                            <div className="mb-3">
                                <label className="form-label">ID</label>
                                <input
                                    value={id}
                                    type="text"
                                    className="form-control"
                                    disabled // ID'yi değiştirmesini engelliyoruz
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Name</label>
                                <input
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    type="text"
                                    className="form-control"
                                    required
                                    style={{
                                        backgroundColor: "#f0f8ff",
                                        border: "1px solid #ced4da",
                                        color: "#333",
                                    }}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Email</label>
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="email"
                                    className="form-control"
                                    required
                                    style={{
                                        backgroundColor: "#f0f8ff",
                                        border: "1px solid #ced4da",
                                        color: "#333",
                                    }}
                                />
                            </div>

                            <button type="submit" className="btn btn-primary">
                                Kaydet
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditUser;
